module.exports = __webpack_public_path__ + "static/image-01-a@2x-747cda8d641bc6ce1a52c82a5045fc71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/deliveroo/image-01-a@2x.jpg
// module id = 353
// module chunks = 3627797113349 20562973939449 33019919093843